import React, { useState } from "react";
import 'fontsource-roboto';
import 'devicon';
import "animate.css/animate.min.css";
import "../styles/main.css";
import "devicon";

import { Parallax, ParallaxLayer } from 'react-spring/renderprops-addons';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, IconButton } from "@material-ui/core";

import SEO from "../components/seo";
import Header from "../components/Header";
// import Bio from "../components/Bio";
import Mastery from "../components/Mastery";
// import Stats from "../components/Stats";
// import Experience from "../components/Experience";

import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import bgLight from "../svgs/bg-light.svg"
import bgDark from "../svgs/bg-dark.svg"

library.add(fab, fas, far)

function IndexPage() {
  const [darkMode, setDarkMode] = useState(false)

  const theme = React.useMemo(
    () =>
    createMuiTheme({
      palette: {
        type: darkMode ? 'dark' : 'light',
        primary: {
          main: "#9e9e9e",
          dark: "#707070",
          light: "#cfcfcf"
        },
        secondary: {
          main: '#9c27b0',
          light: '#d05ce3',
          dark : '#6a0080'
        },
        text: {
          primary: '#263238',
          secondary: '#ffffff'
        },
        background: {
          default: darkMode ? '#212121' : '#fff7fe'
        },
        divider: '#9c27b0'
      },
      typography: {
        fontFamily: '"Titillium Web", "Roboto", sans-serif' 
      },
      overrides: {
        MuiCssBaseline: {
          '@global': {
            body: {
              height:  '100%',
              width:  '100%',
              margin: 0,
              padding: 0,
              transition: 'background-color 1s ease, background-image 0.5s ease',
              WebkitTransition: 'background-color 1s ease, background-image 0.5s ease',
              backgroundImage: `url(${darkMode ? bgDark : bgLight})`
            }
          }
        }
      }
    }),
    [darkMode]
  );
  
  return <Container disableGutters maxWidth={false} >
    <SEO title="Home" />
    <ThemeProvider theme={theme}>
    <CssBaseline />
      <Parallax pages={2}>
        <ParallaxLayer
          offset={0.01} 
          speed={15}
        >
          <IconButton 
            onClick={() => setDarkMode(!darkMode)} 
            style={{ marginLeft: '95%'}}
          >
            <FontAwesomeIcon icon={['fas', 'meteor']} />
          </IconButton>
        </ParallaxLayer>
        <Header darkMode={darkMode} />
        {/* <Bio darkMode={darkMode} /> */}
        <Mastery darkMode={darkMode} />
        {/* <Experience darkMode={darkMode} />  */}
      </Parallax>
    </ThemeProvider>
  </Container>
}

export default IndexPage
